module.exports = "/_next/static/images/twitter-simple-e9396264d5ef581af6af96b1b12214d8.svg";